// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"145":"bb77d8d5","404":"47f53670","599":"c27e1dbb","920":"e9128614"}[chunkId] + ".chunk.css";
};